<template>
  <div class="linkUploadWorkspace">
    <div class="linkUploadWorkspace__shell">
      <header class="linkUploadWorkspace__header">
        <h1 class="linkUploadWorkspace__title">文件上传</h1>
        <el-button
          v-if="uploadList.length"
          class="actionButton actionButtonGhost"
          size="small"
          icon="el-icon-delete"
          @click="clearAll"
        >
          清空列表
        </el-button>
      </header>

      <div
        class="linkUploadWorkspace__body"
        :class="{ 'linkUploadWorkspace__body--empty': !uploadList.length }"
      >
        <div class="linkUploadDialog__dropzone linkUploadWorkspace__drop">
          <el-upload
            drag
            action=""
            multiple
            :http-request="handleCustomUpload"
            :show-file-list="false"
          >
            <i class="el-icon-upload" />
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
          <p class="linkUploadDialog__tip">支持任意格式，可多文件同时上传；成功后可复制 CDN 链接</p>
        </div>

        <div v-if="uploadList.length" class="linkUploadWorkspace__table">
          <el-table
            class="linkTable linkTable--hybrid"
            :data="uploadList"
            style="width: 100%"
          >
            <el-table-column label="预览" width="100" align="center" header-align="center">
              <template slot-scope="scope">
                <div class="linkUploadWorkspace__preview">
                  <el-image
                    v-if="isImage(scope.row.type || scope.row.name)"
                    :src="scope.row.url"
                    :preview-src-list="[scope.row.url]"
                    fit="cover"
                    lazy
                  >
                    <div slot="placeholder" class="previewCell__slot">
                      <i class="el-icon-loading" />
                    </div>
                    <div slot="error" class="previewCell__slot previewCell__slot--error">
                      <i class="el-icon-picture-outline" />
                    </div>
                  </el-image>
                  <i v-else class="el-icon-document" />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="文件名"
              min-width="180"
              show-overflow-tooltip
              align="center"
              header-align="center"
            />
            <el-table-column label="上传状态" width="180" align="center" header-align="center">
              <template slot-scope="scope">
                <el-progress
                  v-if="scope.row.status === 'uploading'"
                  :percentage="scope.row.percentage"
                />
                <el-tag v-else-if="scope.row.status === 'success'" type="success" size="small">
                  上传成功
                </el-tag>
                <el-tag v-else-if="scope.row.status === 'error'" type="danger" size="small">
                  上传失败
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              label-class-name="linkListActionColumnHead"
              width="200"
              align="center"
              header-align="center"
              class-name="actionColumn"
            >
              <template slot="header">
                <span class="linkListActionColumnHead__label">操作</span>
              </template>
              <template slot-scope="scope">
                <div class="linkTableActionCell">
                  <el-button
                    v-if="scope.row.status === 'success'"
                    size="small"
                    class="rowActionBtn rowActionBtn--ghost"
                    icon="el-icon-document-copy"
                    @click="copyUrl(scope.row.url)"
                  >
                    复制链接
                  </el-button>
                  <el-button
                    size="small"
                    class="rowActionBtn rowActionBtn--ghost"
                    icon="el-icon-delete"
                    @click="removeFile(scope.$index)"
                  >
                    删除
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { uploadFile } from '@/api/comment'
// 投放区 / 工作台表面样式已在 Layout 全局挂载 linkUploadSurfaces.css；此处只补按钮 token
import '../../resourceManage/genericResourceManage/linkActionButtons.css'

export default {
  name: 'uploadFileManage',
  data() {
    return {
      uploadList: [],
    }
  },
  methods: {
    async handleCustomUpload(options) {
      const { file } = options
      const fileId = Date.now() + Math.random().toString(36).substring(2, 9)

      const localUrl = URL.createObjectURL(file)
      const newFile = {
        id: fileId,
        name: file.name,
        type: file.type,
        status: 'uploading',
        percentage: 0,
        url: localUrl,
        localUrl: localUrl,
      }
      this.uploadList.unshift(newFile)

      const formData = new FormData()
      formData.append('file', file)

      try {
        const res = await uploadFile(formData)
        if (res.success) {
          const index = this.uploadList.findIndex((item) => item.id === fileId)
          if (index !== -1) {
            const updatedItem = {
              ...this.uploadList[index],
              status: 'success',
              url: res.data,
              percentage: 100,
            }
            this.$set(this.uploadList, index, updatedItem)
          }
        } else {
          this.handleError(fileId)
        }
      } catch (error) {
        this.handleError(fileId)
      }
    },
    handleError(fileId) {
      const index = this.uploadList.findIndex((item) => item.id === fileId)
      if (index !== -1) {
        this.$set(this.uploadList, index, {
          ...this.uploadList[index],
          status: 'error',
        })
      }
      this.$message.error('上传失败')
    },
    copyUrl(url) {
      const input = document.createElement('input')
      input.setAttribute('value', url)
      document.body.appendChild(input)
      input.select()
      if (document.execCommand('copy')) {
        this.$message.success('链接已复制到剪贴板')
      }
      document.body.removeChild(input)
    },
    removeFile(index) {
      const item = this.uploadList[index]
      if (item.localUrl) {
        URL.revokeObjectURL(item.localUrl)
      }
      this.uploadList.splice(index, 1)
    },
    clearAll() {
      this.$confirm('确定清空所有记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.uploadList.forEach((item) => {
          if (item.localUrl) {
            URL.revokeObjectURL(item.localUrl)
          }
        })
        this.uploadList = []
      })
    },
    isImage(typeOrName) {
      if (!typeOrName) return false
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg']
      const fileExt = typeOrName.split('.').pop().toLowerCase()
      return typeOrName.startsWith('image/') || imageExtensions.includes(fileExt)
    },
  },
  beforeDestroy() {
    this.uploadList.forEach((item) => {
      if (item.localUrl) {
        URL.revokeObjectURL(item.localUrl)
      }
    })
  },
}
</script>
